import(/* webpackMode: "eager" */ "/app/apps/consumer/app/(public)/product/[id]/[title]/error.tsx");
